import React from 'react'
import { Accordion, Icon } from 'semantic-ui-react'
import 'semantic-ui-css/components/accordion.min.css'
import 'semantic-ui-css/components/icon.min.css'

class AccordionHeading extends React.Component {
  render() {
    const { children, onClick, index, active } = this.props

    return (
      <Accordion.Title
        as="h4"
        active={active}
        index={index}
        onClick={onClick}
        style={{ margin: '0px !important', fontFamily: 'inherit !important' }}
      >
        <Icon name="dropdown" /> {children}
      </Accordion.Title>
    )
  }
}

export default class MarkdownAccordion extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      activeIndex: parseInt(props.initial || 0, 10),
    }
  }

  handleClick = (e, titleProps) => {
    const { index } = titleProps
    const { activeIndex } = this.state
    const newIndex = activeIndex === index ? -1 : index

    this.setState({ activeIndex: newIndex })
  }

  static renderers = {
    heading: AccordionHeading,
    paragraph: ({ children, active }) => (
      <Accordion.Content active={active}>{children}</Accordion.Content>
    ),
    list: ({ children, active, ...props }) => (
      <Accordion.Content active={active}>
        <ul style={{ marginTop: '0px' }}>{children}</ul>
      </Accordion.Content>
    ),
    item: ({ children, ...props }) => (
      <li style={{ marginBottom: '10px' }}>{children}</li>
    ),
  }

  render() {
    const { children } = this.props
    let index = 0
    return (
      <Accordion>
        {React.Children.map(children, child => {
          if (child.type === AccordionHeading) index++
          return React.cloneElement(child, {
            active: this.state.activeIndex === index,
            index,
            onClick: this.handleClick,
          })
        })}
      </Accordion>
    )
  }
}
